// BatStateFetcher.js
//
// Initial state of all batteries in one call (cdpcode/battery/states).
// Singleton export per Coding Rule - Definitions #2 (rk=f15c11c2ee00410ea4381312ac9320).
import batteryStateService from '@/services/BatteryStateService';
import CoreBase from '../../../services/engines/CoreBase';

const _name = 'BatStateFetcher';

class BatStateFetcher extends CoreBase {
    _name = _name;

    /**
     * Fetches the last known state of all batteries.
     * @returns {Promise<object[]>}
     */
    fetch = async () => {
        try {
            const res = await batteryStateService.getStates();
            return res?.data?.items ?? [];
        } catch (error) {
            this.logError('fetch', error.message);
            return [];
        }
    };
}

const batStateFetcher = new BatStateFetcher();
export default batStateFetcher;
